<template>
  <div>
    <RoomCalendar v-if="userInfo.type==3&&!isGroup"></RoomCalendar>
    <Findhotel v-if="userInfo.type==2&&!isGroup"></Findhotel>
    <AdminHome v-if="isAdmin"></AdminHome>
  </div>
</template>

<script>
import { mapGetters, mapActions,mapState } from 'vuex'
import Findhotel from './Findhotel/index'        //旅行社找酒店
import AdminHome from './AdminHome/index'        //管理员首页
import RoomCalendar from '@/views/StoreInfo/RoomCalendar/index.vue'        //房态日历
export default {
  name: '',
  components: {
    Findhotel,
    AdminHome,
    RoomCalendar
  },
  props: {},
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['userInfo','isGroup','isAdmin']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
